import moment from "moment";

import { ImportClickableTextEnum } from "@/Administration/Models/UI/ClickableTexts/ImportClickableTextEnum";
import { LanguageOptions } from "@/Administration/Models/UI/Enums/Administration";
import { ClickableTextSectionEnum } from "@/Administration/Models/UI/Users/ClickableTextSectionEnum";
import { IUsersSearchModel } from "@/Administration/Models/UI/Users/IUsersSearchModel";
import { UserEditMode } from "@/Administration/Models/UI/Users/UserEditMode";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { OrphanLabForwardDTO } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { RemoveButton } from "@/Common/Components/Buttons/RemoveButton";
import { Autocomplete } from "@/Common/Components/Inputs/Autocomplete";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { RadioButtonv2 } from "@/Common/Components/Inputs/RadioButtonv2";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { ClinicianSearchStrategy, PersonSearchAutocompleteCustom } from "@/Common/Components/Search/PersonSearchAutocompleteCustom";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { PersonDropdownItem } from "@/Common/Models/UI/Inputs/PersonDropdownItem";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BritishColumbiaObstetricalFileClickableText } from "./BritishColumbiaObstetricalFileClickableText";
import { FaxCoverSheetClickableText } from "./FaxCoverSheetClickableText";
import { GroupSettingsComponent } from "./GroupSettingsComponent";
import { OntarioObstetricalFileClickableText } from "./OntarioObstetricalFileClickableText";
import { PopulationBasedFundingClickableText } from "./PopulationBasedFundingClickableText";
import { QuebecObstetricalFileClickableText } from "./QuebecObstetricalFileClickableText";
import { BaseEditableUserInfoPanelProps } from "./UserDetailsPanelComponent";

import styles from "@/Administration/Components/Users/UserToolsInfoEditComponent.module.scss";

interface UserToolsInfoEditComponentProps extends BaseEditableUserInfoPanelProps {
    extendedSections: ClickableTextSectionEnum[];
    onExtendedSectionsChange: (sections: ClickableTextSectionEnum[]) => void;
}
class UserToolsInfoEditComponentState {
    public isLinkUrlValid: boolean;
    public linksUsful: string[];
    public searchResult: Person[];
    public searchModel: IUsersSearchModel;
    public otherUserForGetCT: Person;

    public isValid: boolean;
    public canSaveTools: boolean;

    public EmployeesFiltered: Immutable.List<SearchableItemModelT<Person>> = Immutable.List([]);
    public itemsOrphanLabs: Immutable.List<SearchableItemModelT<KeyValuePair<string, string>>> = Immutable.List([]);
}

class UserToolsInfoEditComponent extends React.Component<UserToolsInfoEditComponentProps, UserToolsInfoEditComponentState> {
    private c1Paddingtop: React.CSSProperties = { paddingTop: "5px" };
    private c2PaddingLeft: React.CSSProperties = { paddingLeft: "5px", paddingTop: "5px", verticalAlign: "top" };
    private deleteClickableTextSectionStyle: React.CSSProperties = { marginLeft: "5px", textDecoration: "underline", color: "red" };
    private importClickableText: React.CSSProperties = { marginRight: "5px", textDecoration: "underline" };
    private tdImportDelete: React.CSSProperties = { textAlign: "right", width: "100px" };
    private td1Style: React.CSSProperties = { "paddingTop": "5px", "verticalAlign": "top", "width": "265px" };
    private c2PaddingLeftWithWidth: React.CSSProperties = { paddingLeft: "5px", paddingTop: "5px", verticalAlign: "top", width: "265px" };
    private clinicianSearchStrategy: ClinicianSearchStrategy;

    constructor(props: UserToolsInfoEditComponentProps) {
        super(props);
        this.initData(props);

        const user = props.editedUser;
        const listClinicianKP = props.model.get("CliniciansAsKVPList").toArray().filter(x => x.Key != user.ContactId);

        const initialState = new UserToolsInfoEditComponentState();
        initialState.searchModel = props.model.get("UsersSearchModel");
        initialState.searchResult = initialState.searchModel.get("SearchEmployeeResult").toArray();
        initialState.isLinkUrlValid = true;
        initialState.linksUsful = user.Model.UsefulLinks;
        initialState.otherUserForGetCT = null;
        initialState.canSaveTools = this.canSaveTools();
        initialState.EmployeesFiltered = initialState.searchResult
            .map(x => new SearchableItemModelT<Person>(x.NameWithPrefix, x.ContactFacetId, x))
            .toImmutable();
        initialState.itemsOrphanLabs = Immutable.List<SearchableItemModelT<KeyValuePair<string, string>>>(listClinicianKP.map(x => new SearchableItemModelT(x.Value, x.Key)));
        this.state = initialState;
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(prevProps: UserToolsInfoEditComponentProps): void {
        if (this.props.editedUser !== prevProps.editedUser) {
            this.mutateState(s => {
                s.isLinkUrlValid = true;
                s.canSaveTools = this.canSaveTools();

                if (this.state.otherUserForGetCT != null)
                    s.otherUserForGetCT = this.state.otherUserForGetCT;
            });
        }

        if (this.props !== prevProps) {
            this.initData(this.props);
        }
    }

    private initData(nextProps: BaseEditableUserInfoPanelProps): void {
        const user = nextProps.editedUser;
        const cliniciansAndEmployeeGroupsWithoutCurrentUser = cacheStore.CliniciansAndEmployeeGroups.filter(x => x.ContactFacetId != user.Model.ContactFacet_id);
        this.clinicianSearchStrategy = new ClinicianSearchStrategy(cliniciansAndEmployeeGroupsWithoutCurrentUser);
    }

    public render(): JSX.Element {
        let employee = this.props.editedUser;
        let clinicianString = this.getClinicianString();
        let langClickableText = this.props.model.get("LanguageOptionClickableText");
        let selectedLanguageOptionforClickableText = sessionStore.getLanguageStringFromEnum(langClickableText);

        let obstetricalFileProps = {
            user: this.props.editedUser,
            languageOption: this.props.model.get("LanguageOptionClickableText"),
            onAddNewClicakbleText: context => this.showNotePopup(context),
            onEditClickableText: item => this.editTab(item),
            onImport: context => this.openImportClickableTextComponent(context)
        };

        return (
            <div>
                <div className="user-component">
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("SharedInformationLabel")}</h3>
                        </div>
                    </div>
                    <div className="psingle-column practice centered">
                        <div className="tb" style={{ "paddingBottom": "5px" }}>
                            {this.renderSharingInfo()}
                        </div>
                    </div>

                </div>

                {employee.Type === EmployeeType.Practician && (
                    <div className="user-component">
                        <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                            <div className="h">
                                <h3 className="thin-font">{cacheStore.GetString("DynamicPdfAndUsefulLinksLabel")}</h3>
                            </div>
                        </div>
                        <div className="psingle-column practice centered">
                            <div className="tb" style={{ "paddingBottom": "5px" }}>
                                {this.renderPdfAndLinksInfo()}
                            </div>
                        </div>
                    </div>
                )}

                <div className="user-component">
                    <div className="flex-container flex-column heading" style={{ "margin": "20px 25px" }}>
                        <div className="h" style={{ "paddingBottom": "5px" }}>
                            <h3 className="thin-font">{cacheStore.GetString("ClickableTextsLabel")}</h3>
                        </div>
                        <hr className="fullWidth margin-y-0" />
                    </div>
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="psingle-column practice centered">
                            <div className="tb">
                                <div className="tbc">
                                    <div>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="c1" style={this.c2PaddingLeftWithWidth}>
                                                        <label className="form-label"> {cacheStore.GetString("LoadClickableTextUserLabel")}</label>
                                                    </td>
                                                    <td className="c2 flex-display flex-gap-xs" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                                        <div style={{ "width": "350px", "float": "left" }}>
                                                            <TextboxControl
                                                                id="txtEmployee_UserEdit_Add"
                                                                value={clinicianString}
                                                                debounceMs={0}
                                                                RemoveStyle={true}
                                                                className="form-control"
                                                                autoCompleteItems={this.state.EmployeesFiltered}
                                                                onAutoCompleteSelectCallBack={(id: string, model: Person, name: string) => this.onEmployeeInfoSelect(name, model, id)}
                                                                onClickRestrictedSearch={true}
                                                                placeholder=""
                                                            />

                                                        </div>
                                                        <ButtonControl
                                                            onClick={this.loadClickableTextAnotherUser.bind(this)}
                                                            label={cacheStore.GetString("LoadLabel")}
                                                            variant="brand"
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="c1" style={this.c2PaddingLeftWithWidth}>
                                                        <label className="form-label" style={{ "paddingTop": "15px" }}> {cacheStore.GetString("LanguageLabel")}</label>
                                                    </td>
                                                    <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                                        <div style={{ "width": "350px", "verticalAlign": "top" }}>
                                                            <RadioButtonv2
                                                                cssClass="settings-user-radioWidth"
                                                                title={null}
                                                                items={[
                                                                    new KeyValuePair("fr", cacheStore.GetString("FrenchLabelD")),
                                                                    new KeyValuePair("en", cacheStore.GetString("EnglishLabelD")),
                                                                    new KeyValuePair("es-MX", cacheStore.GetString("SpanishLabelD"))
                                                                ].toImmutable()}
                                                                htmlName="prescription"
                                                                onChangeCallback={item => this.onChangeLanguageClickableText(item)}
                                                                selectedItem={selectedLanguageOptionforClickableText}
                                                                styleForEachradio={{ width: "22%", float: "left", marginTop: "5px" }}
                                                            />

                                                        </div>

                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.obstetrcialFileWidthOverride}>
                        {employee.Type === EmployeeType.Practician &&
                        this.renderClickableTextOptions(ClickableTextSectionEnum.ClinicalNote, "ClinicalNoteLabel", this.renderClickableNote())
                        }
                        {employee.hasSiteInProvince(CanadaState.Quebec) && cacheStore.ClinicSettings.EnableQuebecObstetricalFile &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.QuebecObstetricalFile,
                            "QuebecObstetricalFileLabel",
                            <QuebecObstetricalFileClickableText
                                {...obstetricalFileProps}
                                onDelete={(context, label) => this.openWarningDeleteClickableTextSection(context, cacheStore.GetString("QuebecObstetricalFileLabel"), label)}
                            />
                        )
                        }
                        {employee.hasSiteInProvince(CanadaState.Ontario) && cacheStore.ClinicSettings.EnableOntarioObstetricalFile &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.OntarioObstetricalFile,
                            "OntarioObstetricalFileLabel",
                            <OntarioObstetricalFileClickableText
                                {...obstetricalFileProps}
                                onDelete={(context, label) => this.openWarningDeleteClickableTextSection(context, cacheStore.GetString("OntarioObstetricalFileLabel"), label)}
                            />
                        )
                        }
                        {employee.hasSiteInProvince(CanadaState.BritishColumbia) && cacheStore.ClinicSettings.EnableBritishColumbiaObstetricalFile &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.BritishColumbiaObstetricalFile,
                            "BritishColumbiaObstetricalFileLabel",
                            <BritishColumbiaObstetricalFileClickableText
                                {...obstetricalFileProps}
                                onDelete={(context, label) => this.openWarningDeleteClickableTextSection(context, cacheStore.GetString("BritishColumbiaObstetricalFileLabel"), label)}
                            />
                        )
                        }
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.Recalls, "RecallsLabel", this.renderRecall())}
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.InboundFax, "InboundFaxLabel", this.renderInboundFax())}
                        {cacheStore.ClinicSettings.EnableFaxCoverSheet && this.renderClickableTextOptions(
                            ClickableTextSectionEnum.FaxCoverSheet,
                            "FaxCoverSheet_FaxCoverSheetLabel",
                            <FaxCoverSheetClickableText
                                td1Style={this.td1Style}
                                tdImportDelete={this.tdImportDelete}
                                importClickableText={this.importClickableText}
                                deleteClickableTextSectionStyle={this.deleteClickableTextSectionStyle}
                                user={this.props.editedUser}
                                userEditMode={this.props.model.get("UserEditMode")}
                                languageOptions={this.props.model.get("LanguageOptionClickableText")}
                                editTab={p => this.editTab(p)}
                                showNotePopup={p => this.showNotePopup(p)}
                                openImportClickableTextComponent={p => this.openImportClickableTextComponent(p)}
                                openWarningDeleteClickableTextSection={(context, sectionName, subSectionName) => this.openWarningDeleteClickableTextSection(context, sectionName, subSectionName)}
                            />
                        )
                        }
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.Messages, "MessagesLabel", this.renderMessages())}
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.Tasks, "TaskLabel", this.renderTasks())}
                        {cacheStore.ClinicSettings.EnablePopulationBasedFunding &&
                        this.renderClickableTextOptions(
                            ClickableTextSectionEnum.PopulationBasedFunding,
                            "PopulationBasedFundingLabel",
                            <PopulationBasedFundingClickableText
                                user={this.props.editedUser}
                                languageOption={this.props.model.get("LanguageOptionClickableText")}
                                importDeleteSectionStyle={this.tdImportDelete}
                                importClickableTextStyle={this.importClickableText}
                                deleteClickableTextStyle={this.deleteClickableTextSectionStyle}
                                onAddNewClicakbleText={context => this.showNotePopup(context)}
                                onEditClickableText={item => this.editTab(item)}
                                onImport={context => this.openImportClickableTextComponent(context)}
                                onDelete={(context, label) => this.openWarningDeleteClickableTextSection(context, cacheStore.GetString("PopulationBasedFundingLabel"), label)}
                            />
                        )
                        }
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.PrescriptionRenewalNotes, "PrescriptionRenewalLabel", this.renderPrescriptionRenewalNotes())}
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.ResultNotes, "ResultLabel", this.renderResultNotes())}
                        {this.renderClickableTextOptions(ClickableTextSectionEnum.PortalCommunications, "SharedItem_PortalCommunicationsLabel", this.renderPortalCommunicationNotes())}
                    </div>
                </div>
            </div>
        );
    }

    private renderSharingInfo(): JSX.Element {
        let user = this.props.editedUser;
        let sharedMessageUsers = cacheStore.CliniciansAndEmployeeGroups.filter(
            (c: Person) => (user.Model.MessagesSharing != null && user.Model.MessagesSharing.some((z: string) => z == c.ContactId))
        );

        let sharedTasksUsers = cacheStore.CliniciansAndEmployeeGroups.filter(
            (c: Person) => (user.Model.TasksSharing != null && user.Model.TasksSharing.some((z: string) => z == c.ContactId))
        );

        let sharedExternalCommunicationsUsers = cacheStore.CliniciansAndEmployeeGroups.filter(
            (c: Person) => (user.Model.ExternalCommunicationsSharing != null && user.Model.ExternalCommunicationsSharing.some((z: string) => z == c.ContactId))
        );

        const sharedPortalCommunicationsUsers: ReadonlyArray<Readonly<Person>> = cacheStore.ClinicSettings.EnableBidirectionalCommunication ?
            cacheStore.CliniciansAndEmployeeGroups.filter(
                person => user
                    .Model
                    .PortalCommunicationsSharing
                    ?.some(sharingEmployeeId => sharingEmployeeId == person.ContactId)
            ) : [];

        let hasLicenceNumber: boolean = false;
        if (user.Model.Licences && user.Model.Licences.length > 0) {
            if (user.Model.Licences[0].LicenceNumber)
                hasLicenceNumber = true;
        }

        let clinicianName = this.props.model.get("ClinicianNameForOrphanLabs");

        let isSelectedClinicianAlreadyAdded = false;
        if (!IsNullOrWhiteSpace(clinicianName)) {
            if (this.props.editedUser && this.props.editedUser.Model && this.props.editedUser.Model.OrphanLabForwardDTOs) {
                isSelectedClinicianAlreadyAdded = this.props.editedUser.Model.OrphanLabForwardDTOs.filter(c => c.ForwardedToName.trim() === clinicianName.trim()).length > 0;
            }
        }

        let fromDate = this.props.model.get("ClinicianDateFromOrphanLabs");
        let toDate = this.props.model.get("ClinicianDateToOrphanLabs");
        let isFromDateValid: boolean = true;
        let isToDateValid: boolean = true;
        if (fromDate != null) {
            if (toDate != null && fromDate > toDate) isFromDateValid = false;
        }
        if (toDate != null) {
            if (fromDate != null && fromDate > toDate) isToDateValid = false;
        }

        return (
            <div className="tbc">
                {cacheStore.ClinicSettings.EnableUserSettingsUiImprovements && this.props.editedUser.Model.Type !== EmployeeType.Api && (
                    <div className={styles.groupSettingsComponentContainer}>
                        <GroupSettingsComponent
                            onDeleteGroupCallback={groupId => this.onDeleteGroup(groupId)}
                            onGroupSelectCallback={groupItem => this.onGroupInfoSelect(groupItem)}
                            selectedGroups={user.Model.Groups}
                            editable={true}
                            className="group-settings-edit"
                        />
                    </div>
                )}
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={{ paddingTop: "5px", width: "265px" }}><label className="form-label">{cacheStore.GetString("ResultsLabel")}</label></td>
                                <td className="c2" style={this.c1Paddingtop}>
                                    <div>
                                        <CheckboxControl
                                            id="employee_ShareResultsDLabel"
                                            onChange={(isChecked: boolean) => this.props.mutateParentEmployee(emp => emp.Model.IsSharingLabs = isChecked)}
                                            target={CheckboxTarget.Unassigned}
                                            label={cacheStore.GetString("ShareResultsDLabel")}
                                            checked={user.Model.IsSharingLabs}
                                        />
                                    </div>
                                </td>
                                <td style={{ "width": "10%" }} />
                            </tr>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                    <label className="form-label">{cacheStore.GetString("MessagesSharedWithLabel")}</label>
                                </td>
                                <td className="c2" style={this.c2PaddingLeft}>
                                    <PersonSearchAutocompleteCustom
                                        componentId="shared_msg_with_ctrl"
                                        disabled={false}
                                        focusOnLoad={false}
                                        selectedItemList={Immutable.List(sharedMessageUsers)}
                                        allowMultipleItemSelection
                                        searchStrategy={this.clinicianSearchStrategy}
                                        closeDropDownAfterSelection={true}
                                        onClearCallback={(personItem: PersonDropdownItem) =>
                                            this.props.mutateParentEmployee(emp => emp.Model.MessagesSharing = this.handleOnPersonClear(emp.Model.MessagesSharing, personItem))
                                        }
                                        onSelectionCallback={(personItem: PersonDropdownItem) =>
                                            this.props.mutateParentEmployee(emp => emp.Model.MessagesSharing = this.handleOnSharedWithSelectionChange(this.props.editedUser.Model.MessagesSharing, personItem))
                                        }
                                    />
                                </td>
                                <td style={{ "width": "10%" }} />
                            </tr>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top", width: "265px" }}><label className="form-label">{cacheStore.GetString("TasksSharedWithLabel")}</label></td>
                                <td className="c2" style={this.c2PaddingLeft}>
                                    <PersonSearchAutocompleteCustom
                                        componentId="shared_task_with_ctrl"
                                        disabled={false}
                                        focusOnLoad={false}
                                        selectedItemList={Immutable.List(sharedTasksUsers)}
                                        allowMultipleItemSelection
                                        closeDropDownAfterSelection
                                        searchStrategy={this.clinicianSearchStrategy}
                                        onClearCallback={(personItem: PersonDropdownItem) => this.props.mutateParentEmployee(emp => emp.Model.TasksSharing = this.handleOnPersonClear(emp.Model.TasksSharing, personItem))}
                                        onSelectionCallback={(personItem: PersonDropdownItem) =>
                                            this.props.mutateParentEmployee(emp => emp.Model.TasksSharing = this.handleOnSharedWithSelectionChange(this.props.editedUser.Model.TasksSharing, personItem))
                                        }
                                    />
                                </td>
                                <td style={{ "width": "10%" }} />
                            </tr>
                            {cacheStore.ClinicSettings.EnableExternalCommunication && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top", width: "265px" }}>
                                        <label
                                            style={{ width: "220px" }}
                                            className="form-label"
                                        >
                                            {cacheStore.GetString("ExternalCommunicationSharedWithLabel")}
                                        </label>
                                    </td>
                                    <td className="c2" style={this.c2PaddingLeft}>
                                        <PersonSearchAutocompleteCustom
                                            componentId="shared_xcom_with_ctrl"
                                            disabled={false}
                                            focusOnLoad={false}
                                            selectedItemList={Immutable.List(sharedExternalCommunicationsUsers)}
                                            allowMultipleItemSelection
                                            closeDropDownAfterSelection={true}
                                            searchStrategy={this.clinicianSearchStrategy}
                                            onClearCallback={(personItem: PersonDropdownItem) =>
                                                this.props.mutateParentEmployee(emp => emp.Model.ExternalCommunicationsSharing = this.handleOnPersonClear(emp.Model.ExternalCommunicationsSharing, personItem))
                                            }
                                            onSelectionCallback={personItem => this.props.mutateParentEmployee(
                                                emp => emp.Model.ExternalCommunicationsSharing = this.handleOnSharedWithSelectionChange(this.props.editedUser.Model.ExternalCommunicationsSharing, personItem)
                                            )}
                                        />
                                    </td>
                                    <td style={{ "width": "10%" }} />
                                </tr>
                            )}
                            {cacheStore.ClinicSettings.EnableBidirectionalCommunication && (
                                <>
                                    {(cacheStore.ClinicSettings.EnablePatientInitiatedBidirectionalCommunication && !user.isClerical()) && (
                                        <tr>
                                            <td className="c1" style={{ paddingTop: "5px", width: "265px" }}><label className="form-label">{cacheStore.GetString("SharedItem_PortalCommunicationsLabel")}</label></td>
                                            <td className="c2" style={this.c1Paddingtop}>
                                                <div>
                                                    <CheckboxControl
                                                        id="employee_EnablePatientsToInitiatePortalMessagesLabel"
                                                        onChange={(isChecked: boolean) => this.props.mutateParentEmployee(emp => emp.Model.AllowPatientsToInitiatePortalMessages = isChecked)}
                                                        target={CheckboxTarget.Unassigned}
                                                        label={cacheStore.GetString("Administration_EnablePatientsToInitiatePortalMessagesWithProviderLabel")}
                                                        checked={user.Model.AllowPatientsToInitiatePortalMessages}
                                                        labelClassName={styles.breakWordCheckboxLabel}
                                                    />
                                                </div>
                                            </td>
                                            <td style={{ "width": "10%" }} />
                                        </tr>
                                    )}
                                    <tr>
                                        <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top", width: "265px" }}>
                                            <label
                                                style={{ width: "220px" }}
                                                className="form-label"
                                            >
                                                {cacheStore.GetString("SharedItem_PortalCommunicationsSharedWithLabel")}
                                            </label>
                                        </td>
                                        <td className="c2" style={this.c2PaddingLeft}>
                                            <PersonSearchAutocompleteCustom
                                                componentId="shared_portal_communication_with_ctrl"
                                                disabled={false}
                                                focusOnLoad={false}
                                                selectedItemList={Immutable.List(sharedPortalCommunicationsUsers)}
                                                allowMultipleItemSelection
                                                closeDropDownAfterSelection={true}
                                                searchStrategy={this.clinicianSearchStrategy}
                                                onClearCallback={(personItem: PersonDropdownItem) =>
                                                    this.props.mutateParentEmployee(
                                                        employee => employee.Model.PortalCommunicationsSharing =
                                                        this.handleOnPersonClear(employee.Model.PortalCommunicationsSharing, personItem)
                                                    )
                                                }
                                                onSelectionCallback={personItem =>
                                                    this.props.mutateParentEmployee(
                                                        employee =>
                                                            employee.Model.PortalCommunicationsSharing = this.handleOnSharedWithSelectionChange(
                                                                this.props.editedUser.Model.PortalCommunicationsSharing,
                                                                personItem
                                                            )
                                                    )
                                                }
                                            />
                                        </td>
                                        <td style={{ "width": "10%" }} />
                                    </tr>
                                </>
                            )}
                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit && hasLicenceNumber) && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "center" }}><label className="form-label">{cacheStore.GetString("TransferResultLabel")}</label></td>
                                    <td className="c2" style={{ "paddingTop": "5px", "width": "700px", "paddingLeft": "5px" }}>
                                        <div className="flex-container">
                                            <div className="flex-grow-1 push-right-5">
                                                <TextboxControl
                                                    debounceMs={200}
                                                    value={this.props.model.get("ClinicianNameForOrphanLabs")}
                                                    autoCompleteItems={this.state.itemsOrphanLabs}
                                                    onAutoCompleteSelectCallBack={(code: string, model: any, name: string) => {
                                                        sessionStore.dispatch(LocalOperations.AdministrationUsers.OrphanLabsClinicianChange, { value: code, name: name });
                                                    }}
                                                    onAutoCompleteSelectClearTextBox={false}
                                                    placeholder=""
                                                    autoComplete="off"
                                                    valid={!isSelectedClinicianAlreadyAdded}
                                                    id="_orphabLabs_Textbox"
                                                />
                                            </div>
                                            <div className="push-right-5">
                                                <DateSelector
                                                    id="labs_from"
                                                    width={140}
                                                    height={38}
                                                    disabled={false}
                                                    cssClass="rounded"
                                                    dateFormat="yyyy/MM/dd"
                                                    minDate={new Date()}
                                                    autoComplete="off"
                                                    onSelectOp={LocalOperations.AdministrationUsers.OrphanLabsFromChange}
                                                    date={this.props.model.get("ClinicianDateFromOrphanLabs")}
                                                    valid={isFromDateValid}
                                                />
                                            </div>
                                            <div>
                                                <DateSelector
                                                    id="labs_to"
                                                    width={140}
                                                    height={38}
                                                    disabled={false}
                                                    cssClass="rounded"
                                                    minDate={new Date()}
                                                    autoComplete="off"
                                                    dateFormat="yyyy/MM/dd"
                                                    onSelectOp={LocalOperations.AdministrationUsers.OrphanLabsToChange}
                                                    date={this.props.model.get("ClinicianDateToOrphanLabs")}
                                                    valid={isToDateValid}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ "width": "5%", "paddingTop": "8px" }}>
                                        <div className="myle-column save" style={{ "paddingTop": "5px" }}>
                                            {(this.props.model.get("ClinicianIdForOrphanLabs") !== "") && isFromDateValid && isToDateValid && !isSelectedClinicianAlreadyAdded && (
                                                <a
                                                    onClick={() => this.addClinicianToOrphanLabList()}
                                                    style={{ textDecoration: "underline" }}
                                                >
                                                    <strong>{cacheStore.GetString("AddLabel")}</strong>
                                                </a>
                                            )}
                                        </div>
                                    </td>

                                </tr>
                            )}

                            {isSelectedClinicianAlreadyAdded && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px" }} />
                                    <td className="c2" style={{ "paddingTop": "5px", "width": "400px", "paddingLeft": "5px" }}>
                                        <div className="flex-container">
                                            <div className="flex-grow-1 push-right-5">
                                                <label className="label-error"> {cacheStore.GetString("ClinicianAlreadyAddedError")} </label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {user.Model.OrphanLabForwardDTOs != null && user.Model.OrphanLabForwardDTOs.length > 0 && (user.Model.OrphanLabForwardDTOs.map((c: OrphanLabForwardDTO, idx: number) => (
                                <tr key={idx + "_orphLabRow"}>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "center" }} />
                                    <td className="c2">
                                        <div key={idx + "_ck"} className="flex-container">
                                            <div key={"msgClinicians_" + idx} className="flex-container flex-grow-1 push-right-5" style={{ "float": "left", "width": "350px", "whiteSpace": "nowrap", "textOverflow": "ellipsis", "overflow": "hidden" }}>
                                                {c.ForwardedToName} {c.ForwardedTo && (" (" + c.ForwardedTo + ")")}
                                            </div>
                                            <div key={"msgCliniciansDateFrom_" + idx} style={{ width: "140px" }} className="flex-container flex-center push-right-5">
                                                {c.FromDate != null && MyleHelper.ReplaceEmptyString(moment(c.FromDate).format("YYYY/MM/DD"))}
                                            </div>
                                            <div key={"msgCliniciansDateTo_" + idx} style={{ width: "140px" }} className="flex-container flex-center push-right-5">
                                                {c.ToDate != null && MyleHelper.ReplaceEmptyString(moment(c.ToDate).format("YYYY/MM/DD"))}
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ "width": "10%", verticalAlign: "middle" }}>
                                        <RemoveButton
                                            className="padding-sm-left"
                                            onRemove={() => sessionStore.dispatch(LocalOperations.AdministrationUsers.RemoveClinicianFromOrphanLabsList, { value: c.ID })}
                                        />
                                    </td>
                                </tr>
                            )))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderPdfAndLinksInfo(): JSX.Element {
        const self = this;
        let user = this.props.editedUser;
        let usefulLinkUrl: string[] = null;

        let url = user.Model.UsefulLinks;
        if (url != null) {
            if (url.length > 0) {
                let parts = url[0].split(";");
                usefulLinkUrl = parts;
            }
        }
        return (
            <div className="tbc">
                <div>
                    <table>
                        <tbody>

                            <tr>
                                <td className="c1" style={{ paddingTop: "5px", width: "265px" }}><label className="form-label">{cacheStore.GetString("DynamicPdfLabel")}</label></td>
                                <td className="c2" style={{ "paddingLeft": "5px", "verticalAlign": "top", "paddingTop": "2.5px" }}>
                                    <div style={(this.props.model.get("UserEditMode") == UserEditMode.Create) ? { "paddingTop": "3px" } : { "paddingTop": "2.5px" }}>
                                        <Autocomplete
                                            selectionOp={LocalOperations.AdministrationUsers.ChangeTagSelection}
                                            list={cacheStore.radPdfTagsCache}
                                            selectedValue={Immutable.List(this.props.model.get("SelectePDFTagIds"))}
                                            componentId="tags_autocomplete"
                                            autoClose={true}

                                        />
                                    </div>
                                </td>
                                <td style={{ "width": "10%" }} />
                            </tr>

                            <tr>
                                <td className="c1" style={this.c2PaddingLeft}><label className="form-label">{cacheStore.GetString("QuickLinkLabel")}</label></td>
                                <td className="c2" style={this.c2PaddingLeft}>
                                    <TextboxControl
                                        id="usfulLinkAdd"
                                        valid={user.linkValid}
                                        value={null}
                                        className="form-control"
                                        onChange={e => this.props.mutateParentEmployee(emp => {
                                            let valid = emp.isLinkUrlValid(e);
                                            if (valid) sessionStore.dispatch(LocalOperations.AdministrationUsers.AddNewUsefulLink, { NewLink: e });
                                        })}
                                    />

                                </td>
                                <td style={{ "width": "10%" }} />
                            </tr>

                            {usefulLinkUrl != null && (usefulLinkUrl.map((link: string, idx) => {
                                let l = $.trim(link);
                                let href = l;
                                if (l.length === 0) return null;
                                if (l.indexOf("http") < 0) { href = "http://" + l; }
                                return (
                                    <tr key={"linkuseful__" + idx}>
                                        <td className="c1" style={this.c2PaddingLeft}><label className="form-label" /></td>
                                        <td className="c2" style={this.c2PaddingLeft}>
                                            <div key={idx + "_usefulLinks"} style={{ "whiteSpace": "nowrap", "textOverflow": "ellipsis", "overflow": "hidden" }}><a style={{ marginRight: "5px" }} href={href} target="_blank">{l}</a></div>

                                        </td>
                                        <td style={{ "width": "10%", verticalAlign: "middle" }}>
                                            <RemoveButton
                                                className="padding-sm-left"
                                                onRemove={() => self.removeLink(link)}
                                            />
                                        </td>
                                    </tr>
                                );
                            }))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private renderClickableNote(): JSX.Element {
        let user = this.props.editedUser;
        let textList = user.Model.TextList;
        if (textList && textList.length > 0)
            textList.sortByProperty(x => x.TabOrderIndex);
        let textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null) textList = textListAnotherUser.sortByProperty(x => x.TabOrderIndex);

        let langClickableText = this.props.model.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let uniqueArrayNotesReason = (textList) ? user.getAggregatedTabNames("RFV", lang) : [];
        let uniqueArrayNotesHistory = (textList) ? user.getAggregatedTabNames("HPI", lang) : [];
        let uniqueArrayNotesExam = (textList) ? user.getAggregatedTabNames("EXAM", lang) : [];
        let uniqueArrayLabs = (textList) ? user.getAggregatedTabNames("LAB", lang) : [];
        let uniquArrayImages = (textList) ? user.getAggregatedTabNames("IMG", lang) : [];
        let uniqueArrayOthers = (textList) ? user.getAggregatedTabNames("OTHN", lang) : [];
        let uniqueArrayFollowUpPlan = (textList) ? user.getAggregatedTabNames("OTH", lang) : [];
        let uniqueArrayAllConsultation = (textList) ? user.getAggregatedTabNames("CONS", lang) : [];
        let uniqueArrayAllRequest = (textList) ? user.getAggregatedTabNames("REQ", lang) : [];
        let uniqueArrayReqReason = (textList) ? user.getAggregatedTabNames("RFRQ", lang) : [];
        let uniqueArrayConReqReason = (textList) ? user.getAggregatedTabNames("RFCR", lang) : [];

        let sectionName = cacheStore.GetString("ClinicalNoteLabel");

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("ReasonLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("RFV")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayNotesReason?.length > 0 && uniqueArrayNotesReason.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_Notereasons"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayNotesReason.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayNotesReason.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("RFV")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("RFV", sectionName, cacheStore.GetString("ReasonLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("HPILabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("HPI")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayNotesHistory?.length > 0 && uniqueArrayNotesHistory.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_NoteHistory"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayNotesHistory.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayNotesHistory.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("HPI")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("HPI", sectionName, cacheStore.GetString("HPILabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("ExamLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("EXAM")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayNotesExam?.length > 0 && uniqueArrayNotesExam.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_NoteExam"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayNotesExam.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayNotesExam.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("EXAM")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("EXAM", sectionName, cacheStore.GetString("ExamLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("LaboratoryLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("LAB")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayLabs?.length > 0 && uniqueArrayLabs.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_NoteLabs"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayLabs.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayLabs.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("LAB")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("LAB", sectionName, cacheStore.GetString("LaboratoryLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("RadiologyLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("IMG")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniquArrayImages?.length > 0 && uniquArrayImages.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_NoteImages"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniquArrayImages.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniquArrayImages.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("IMG")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("IMG", sectionName, cacheStore.GetString("RadiologyLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("OtherNotesAndInterventionsLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("OTHN")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayOthers?.length > 0 && uniqueArrayOthers.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_others"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayOthers.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayOthers != null && uniqueArrayOthers.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("OTHN")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("OTHN", sectionName, cacheStore.GetString("OtherNotesAndInterventionsLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("RequestsLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("REQ")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayAllRequest?.length > 0 && uniqueArrayAllRequest.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_AllReq"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayAllRequest.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayAllRequest != null && uniqueArrayAllRequest.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("REQ")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("REQ", sectionName, cacheStore.GetString("RequestsLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("RequestReasonLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("RFRQ")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayReqReason?.length > 0 && uniqueArrayReqReason.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_Requestreasons"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayReqReason.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayReqReason.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("RFRQ")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("RFRQ", sectionName, cacheStore.GetString("RequestReasonLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("ConsultationRequestLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("CONS")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayAllConsultation?.length > 0 && uniqueArrayAllConsultation.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_allCons"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayAllConsultation.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayAllConsultation != null && uniqueArrayAllConsultation.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("CONS")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("CONS", sectionName, cacheStore.GetString("ConsultationRequestLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("ConsultationRequestReasonLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("RFCR")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayConReqReason?.length > 0 && uniqueArrayConReqReason.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_ConsultationRequestreasons"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayConReqReason.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayConReqReason.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("RFCR")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("RFCR", sectionName, cacheStore.GetString("ConsultationRequestReasonLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("OtherPlanNoteLbl")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("OTH")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {uniqueArrayFollowUpPlan?.length > 0 && uniqueArrayFollowUpPlan.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_followup"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != uniqueArrayFollowUpPlan.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {uniqueArrayFollowUpPlan != null && uniqueArrayFollowUpPlan.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("OTH")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("OTH", sectionName, cacheStore.GetString("OtherPlanNoteLbl"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderRecall(): JSX.Element {
        let user = this.props.editedUser;
        let unique_array_notesRecall: ClickableTextItem[];
        let textList = user.Model.TextList;
        if (textList && textList.length > 0) user.Model.TextList.sortByProperty(x => x.TabOrderIndex);
        let textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null) textList = textListAnotherUser;
        let langClickableText = this.props.model.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        unique_array_notesRecall = (textList) ? user.getAggregatedTabNames("RNOTES", lang) : [];

        let sectionName = cacheStore.GetString("RecallsLabel");

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>

                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("NotesDLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("RNOTES")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {unique_array_notesRecall?.length > 0 && unique_array_notesRecall.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_Noterecall"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != unique_array_notesRecall.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {unique_array_notesRecall != null && unique_array_notesRecall.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("RNOTES")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("RNOTES", sectionName, cacheStore.GetString("NotesDLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderInboundFax(): JSX.Element {
        const user = this.props.editedUser;
        let textList = [...user.Model.TextList];

        if (textList?.any())
            textList.sortByProperty(x => x.TabOrderIndex);

        let textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null) textList = textListAnotherUser;

        const langClickableText = this.props.model.get("LanguageOptionClickableText");
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        const returnFaxToSenderMessages = (textList) ? user.getAggregatedTabNames("ReturnToSenderNotes", lang) : [];
        const sectionName = cacheStore.GetString("ReturnToSenderLabel");

        const regularNotes: ClickableTextItem[] = (textList) ? user.getAggregatedTabNames("InboundFaxNotes", lang) : [];

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("ReturnToSenderNotesLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("ReturnToSenderNotes")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>{returnFaxToSenderMessages != null && returnFaxToSenderMessages.length > 0 &&
                                                returnFaxToSenderMessages.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_Noterecall"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != returnFaxToSenderMessages.length - 1) && " , "}
                                                    </a>
                                                ))
                                            }
                                                {returnFaxToSenderMessages != null && returnFaxToSenderMessages.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("ReturnToSenderNotes")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("ReturnToSenderNotes", sectionName, cacheStore.GetString("ReturnToSenderNotesLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("NotesDLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("InboundFaxNotes")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {regularNotes?.length > 0 && regularNotes.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_Noterecall"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != regularNotes.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {regularNotes != null && regularNotes.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("InboundFaxNotes")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("InboundFaxNotes", sectionName, cacheStore.GetString("NotesDLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderPrescriptionRenewalNotes(): JSX.Element {
        const user = this.props.editedUser;
        let textList = [...user.Model.TextList];

        if (textList?.any())
            textList.sortByProperty(x => x.TabOrderIndex);

        let textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null)
            textList = textListAnotherUser;

        const langClickableText = this.props.model.get("LanguageOptionClickableText");
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        const sectionName = cacheStore.GetString("PrescriptionRenewalLabel");
        const prescriptionRenewalNotes: ClickableTextItem[] = (textList) ? user.getAggregatedTabNames("PrescriptionRenewalNotes", lang) : [];

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("NotesLabel")}</label>
                                            {(this.props.model.get("UserEditMode") === UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("PrescriptionRenewalNotes")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {prescriptionRenewalNotes?.length > 0 && prescriptionRenewalNotes.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_Noterecall"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != prescriptionRenewalNotes.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {prescriptionRenewalNotes != null && prescriptionRenewalNotes.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("PrescriptionRenewalNotes")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("PrescriptionRenewalNotes", sectionName, cacheStore.GetString("NotesLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderResultNotes(): JSX.Element {
        const user = this.props.editedUser;
        let textList = [...user.Model.TextList];

        if (textList?.any())
            textList.sortByProperty(x => x.TabOrderIndex);

        const textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null)
            textList = textListAnotherUser;

        const langClickableText = this.props.model.get("LanguageOptionClickableText");
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        const sectionName = cacheStore.GetString("ResultLabel");
        const resultNotes: ClickableTextItem[] = (textList) ? user.getAggregatedTabNames("ResultNotes", lang) : [];

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("NotesLabel")}</label>
                                            {(this.props.model.get("UserEditMode") === UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("ResultNotes")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {resultNotes?.length > 0 && resultNotes.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_Noterecall"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != resultNotes.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {resultNotes != null && resultNotes.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("ResultNotes")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("ResultNotes", sectionName, cacheStore.GetString("NotesLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderMessages(): JSX.Element {
        let user = this.props.editedUser;
        let textList = user.Model.TextList;
        if (textList && textList.length > 0) textList.sortByProperty(x => x.TabOrderIndex);
        let textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null) textList = textListAnotherUser.sortByProperty(x => x.TabOrderIndex);
        let langClickableText = this.props.model.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let unique_array_message = (textList) ? user.getAggregatedTabNames("SMESSAGES", lang) : [];
        let unique_array_bMessages = (textList) ? user.getAggregatedTabNames("BMESSAGES", lang) : [];

        let sectionname = cacheStore.GetString("MessagesLabel");

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>

                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("SubjectLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("SMESSAGES")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {unique_array_message?.length > 0 && unique_array_message.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_msg"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != unique_array_message.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {unique_array_message != null && unique_array_message.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("SMESSAGES")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("SMESSAGES", sectionname, cacheStore.GetString("SubjectLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("BodyLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("BMESSAGES")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {unique_array_bMessages?.length > 0 && unique_array_bMessages.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_bMsg"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != unique_array_bMessages.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {unique_array_bMessages != null && unique_array_bMessages.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("BMESSAGES")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("BMESSAGES", sectionname, cacheStore.GetString("BodyLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderTasks(): JSX.Element {
        let user = this.props.editedUser;
        let textList = user.Model.TextList;
        if (textList && textList.length > 0) textList.sortByProperty(x => x.TabOrderIndex);
        let textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null) textList = textListAnotherUser;
        let langClickableText = this.props.model.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let unique_array_task = (textList) ? user.getAggregatedTabNames("STASKS", lang) : [];
        let unique_array_bTask = (textList) ? user.getAggregatedTabNames("BTASKS", lang) : [];
        let sectionname = cacheStore.GetString("TaskLabel");

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>

                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("SubjectLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("STASKS")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {unique_array_task?.length > 0 && unique_array_task.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_task"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != unique_array_task.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {unique_array_task != null && unique_array_task.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("STASKS")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("STASKS", sectionname, cacheStore.GetString("SubjectLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("BodyLabel")}</label>
                                            {(this.props.model.get("UserEditMode") == UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("BTASKS")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {unique_array_bTask?.length > 0 && unique_array_bTask.map((x: ClickableTextItem, i: number) => (
                                                    <a key={i + "_bTask"} onClick={() => this.editTab(x)}>
                                                        {x.TabName} {(i != unique_array_bTask.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {unique_array_bTask != null && unique_array_bTask.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("BTASKS")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("BTASKS", sectionname, cacheStore.GetString("BodyLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderPortalCommunicationNotes(): JSX.Element {
        const user = this.props.editedUser;
        let textList = [...user.Model.TextList];

        if (textList?.any())
            textList.sortByProperty(p => p.TabOrderIndex);

        const textListAnotherUser = this.props.model.get("ClickableTextSpecificUser");
        if (textListAnotherUser != null)
            textList = textListAnotherUser;

        const langClickableText = this.props.model.get("LanguageOptionClickableText");
        const lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        const sectionName = cacheStore.GetString("SharedItem_PortalCommunicationsLabel");
        const PortalCommunicationsNotes: ClickableTextItem[] = (textList) ? user.getAggregatedTabNames("PORTAL", lang) : [];
        const PortalCommunicationsSubject: ClickableTextItem[] = (textList) ? user.getAggregatedTabNames("PortalSubject", lang) : [];

        return (
            <div className="psingle-column practice centered">
                <div className="tb">
                    <div className="tbc">
                        <div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("SubjectLabel")}</label>
                                            {(this.props.model.get("UserEditMode") === UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("PortalSubject")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {PortalCommunicationsSubject?.length > 0 && PortalCommunicationsSubject.map((p: ClickableTextItem, index: number) => (
                                                    <a key={index + "_PortalSubject"} onClick={() => this.editTab(p)}>
                                                        {p.TabName} {(index != PortalCommunicationsSubject.length - 1) && ", "}
                                                    </a>
                                                ))}
                                                {PortalCommunicationsSubject != null && PortalCommunicationsSubject.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("PortalSubject")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("PortalSubject", sectionName, cacheStore.GetString("SubjectLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.td1Style}>
                                            <label className="form-label" style={{ "paddingRight": "3px" }}>{cacheStore.GetString("NotesLabel")}</label>
                                            {(this.props.model.get("UserEditMode") === UserEditMode.Edit) && (
                                                <a onClick={() => this.showNotePopup("PORTAL")}>
                                                    <strong>[+]</strong>
                                                </a>
                                            )}
                                        </td>
                                        <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}>
                                            <strong>
                                                {PortalCommunicationsNotes?.length > 0 && PortalCommunicationsNotes.map((p: ClickableTextItem, index: number) => (
                                                    <a key={index + "_Noterecall"} onClick={() => this.editTab(p)}>
                                                        {p.TabName} {(index != PortalCommunicationsNotes.length - 1) && " , "}
                                                    </a>
                                                ))}
                                                {PortalCommunicationsNotes != null && PortalCommunicationsNotes.length == 0 && "--"}
                                            </strong>
                                        </td>
                                        <td style={this.tdImportDelete}>
                                            <a onClick={() => this.openImportClickableTextComponent("PORTAL")} style={this.importClickableText}>
                                                <strong>{cacheStore.GetString("ImportLabel")}</strong>
                                            </a>
                                            |
                                            <a onClick={() => this.openWarningDeleteClickableTextSection("PORTAL", sectionName, cacheStore.GetString("NotesLabel"))} style={this.deleteClickableTextSectionStyle}>
                                                <strong>{cacheStore.GetString("DeleteLabel")}</strong>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: UserToolsInfoEditComponentState) => void): void {
        let self = this;
        var s = new UserToolsInfoEditComponentState();
        mutation(s);
        s.canSaveTools = this.canSaveTools();
        if (this.state) {
            s.EmployeesFiltered = this.state.EmployeesFiltered;
            s.itemsOrphanLabs = this.state.itemsOrphanLabs;
        }

        this.setState(s, () => {
            if (self.props.isValidCallBack != null) {
                self.props.isValidCallBack(this.canSaveTools());
            }
        });
    }

    private canSaveTools(): boolean {
        return true;
    }

    private addClinicianToOrphanLabList(): void {
        let user = this.props.editedUser;
        if (user) {
            let operation = new LocalEvent(LocalOperations.AdministrationUsers.AddClinicianToOrphanLabsList);
            operation.AddItem("UserId", user.Model.Contact_id);
            LocalEventDispatcher.dispatch(operation);
        }
    }

    private showNotePopup(noteContext: string): void {
        let user = this.props.editedUser;
        let langClickableText = this.props.model.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);
        let op = new LocalEvent(LocalOperations.MainComponentViewOperations.DisplayCreateClickableText);
        op.AddItem("context", noteContext);
        op.AddItem("isEdit", false);
        op.AddItem("employeeId", user.Model.Contact_id);
        op.AddItem("adminMode", true);
        op.AddItem("languageCode", lang);
        op.AddItem("enumAdminMode", this.props.model.get("UserEditMode"));

        MainComponentStateDispatcher.dispatch(op);

        sessionStore.dispatch(LocalOperations.AdministrationUsers.IsCreateClickableTextOpen);
    }

    private editTab(x: ClickableTextItem): void {
        let user = this.props.editedUser;
        let langClickableText = this.props.model.get("LanguageOptionClickableText");
        let lang = sessionStore.getLanguageStringFromEnum(langClickableText);

        let op = new LocalEvent(LocalOperations.MainComponentViewOperations.DisplayCreateClickableText);
        op.AddItem("context", x.Context);
        op.AddItem("isEdit", true);
        op.AddItem("tabName", x.TabName);
        op.AddItem("employeeId", user.Model.Contact_id);
        op.AddItem("adminMode", true);
        op.AddItem("enumAdminMode", this.props.model.get("UserEditMode"));
        op.AddItem("languageCode", lang);

        if (this.props.model.get("UserEditMode") == UserEditMode.Create) {
            let content = user.Model.TextList.filter(z => z.TabName == x.TabName && z.Context == x.Context);

            op.AddItem("clickableContent", (content && content.length > 0) ? (content[0].ClickableContentItems && content[0].ClickableContentItems.length > 0 ? content[0].ClickableContentItems.toString() : "") : "");
            op.AddItem("isAdminCreateMode", true);
        }

        MainComponentStateDispatcher.dispatch(op);

        sessionStore.dispatch(LocalOperations.AdministrationUsers.IsCreateClickableTextOpen);
    }

    private removeLink(link: string): void {
        this.props.mutateParentEmployee(emp => {
            let parts = emp.Model.UsefulLinks;
            parts = parts[0].split(";");

            let newLink = parts.filter((x: string) => x.toString() === link)[0];
            parts.splice(parts.indexOf(newLink), 1);
            emp.Model.UsefulLinks = [];
            emp.Model.UsefulLinks[0] = parts.join(";");
        });
    }

    private onEmployeeInfoSelect(specialtyName: string, model: Person, id: string): void {
        if (id != null)
            this.mutateState(s => {
                s.otherUserForGetCT = model;
            });
    }

    private loadClickableTextAnotherUser(): void {
        if (this.state.otherUserForGetCT) {
            let item = this.state.otherUserForGetCT.ContactFacetId;
            let otherEmployee = this.state.otherUserForGetCT.NameWithPrefix;
            let currentUser = this.props.editedUser.nameWithPrefix();
            let text1 = cacheStore.GetString("ReplaceAllClickableText1");
            let text2 = cacheStore.GetString("ReplaceAllClickableText2");
            let finalText = text1 + currentUser + text2 + otherEmployee + "!";
            sessionStore.showPopup({
                title: cacheStore.GetString("LoadClickableTextUserLabel"),
                content: finalText,
                showCancel: true,

                okAction: () => sessionStore.dispatch(LocalOperations.AdministrationUsers.LoadClickableTextFromAnotherUser, { EmployeeId: item })
            });
        }
    }

    private getClinicianString(): string {
        let clinician = this.state.otherUserForGetCT;
        if (clinician != null)
            return clinician.NameWithPrefix;
        else
            return "";
    }

    private openWarningDeleteClickableTextSection(noteContext: string, sectionname: string, subSectionname: string): void {
        let user = this.props.editedUser;
        sessionStore.showPopup({
            title: cacheStore.GetString("DeleteClickableText"),
            content: `${cacheStore.GetString("DeleteClickableTextLabel1")}${sectionname} - ${subSectionname}? ${cacheStore.GetString("DeleteClickableTextLabel2")}`,
            showCancel: true,

            okLabel: cacheStore.GetString("ContinueLabel"),
            okAction: () => sessionStore.dispatch(LocalOperations.AdministrationUsers.DeleteClickableTextSection, { Context: noteContext, EmployeeId: user.Model.Contact_id })
        });
    }

    private openImportClickableTextComponent(context: string, tab?: string): void {
        sessionStore.dispatch(LocalOperations.AdministrationUsers.OpenImportClickableText, { EditedUser: this.props.editedUser, Context: context, Tab: (IsNullOrWhiteSpace(tab) ? ImportClickableTextEnum.Tab : ImportClickableTextEnum.Employee) });
    }

    private onChangeLanguageClickableText(item: KeyValuePair<string, string>): void {
        let lang: LanguageOptions;
        if (item.Key === "en")
            lang = LanguageOptions.English;
        else if (item.Key === "fr")
            lang = LanguageOptions.French;
        else if (item.Key === "es-MX")
            lang = LanguageOptions.Spanish;

        sessionStore.dispatch(LocalOperations.AdministrationUsers.OnChangeLanguageForClickableText, { LanguageOption: lang });
    }

    private handleOnPersonClear(shareWithList: string[], personItem: PersonDropdownItem): string[] {
        if (personItem == null || personItem.Item == null)
            return;

        return shareWithList.filter(x => x != personItem.Item.ContactId);
    }

    private handleOnSharedWithSelectionChange(sharedWithList: string[], personItem: PersonDropdownItem): string[] {
        if (personItem == null || personItem.Item == null)
            return;

        sharedWithList.indexOf(personItem.Item.ContactId) > -1
            ? sharedWithList = sharedWithList.filter(x => x != personItem.Item.ContactId)
            : sharedWithList.push(personItem.Item.ContactId);

        return sharedWithList;
    }

    private renderClickableTextOptions(sectionType: ClickableTextSectionEnum, titleLabel: string, renderContent: JSX.Element): JSX.Element {
        return (
            <div className={`margin-lg-right margin-lg-left ${styles.clickableTextWrapperBorder}`}>
                <div className="flex-container heading clickable-text-row-wrapper">
                    <div className="clickable-text-title" onClick={() => this.onClickableTextSectionToggle(sectionType)}>
                        <h3 className="thin-font">{cacheStore.GetString(titleLabel)}</h3>
                        <span className={`clickable-text-arrow glyphicon glyphicon-chevron-${this.props.extendedSections.contains(sectionType) ? "up" : "down"}`} />
                    </div>
                </div>
                {this.props.extendedSections.contains(sectionType) &&
                    renderContent
                }
            </div>
        );
    }

    private onClickableTextSectionToggle(sectionType: ClickableTextSectionEnum): void {
        const extendedSections = this.props.extendedSections;
        if (!extendedSections)
            return;

        extendedSections.toggleElement(sectionType);
        this.props.onExtendedSectionsChange?.(extendedSections);
    }

    private onDeleteGroup(id: Guid): void {
        this.props.mutateParentEmployee(emp => {
            let group: EmployeeGroup = new EmployeeGroup;
            group.Id = id;
            emp.Model.Groups = emp.Model.Groups.filter(x => x.Id !== group.Id);
        });
    }

    private onGroupInfoSelect(item: EmployeeGroup): void {
        let previousGroup = [];
        if (item != null)
            this.props.mutateParentEmployee(emp => {
                if (emp.Model.Groups) {
                    if (emp.Model.Groups.length > 0)
                        previousGroup = emp.Model.Groups.filter(x => x.Name == item.Name);

                    if (previousGroup.length == 0)
                        emp.Model.Groups.push(item);
                }
                else {
                    emp.Model.Groups = [];
                    emp.Model.Groups.push(item);
                }
            });
    }
}

export { UserToolsInfoEditComponent };
